import { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isLoggedIn } from "../../util/auth";

interface Props {
  children: ReactElement;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const location = useLocation();

  if (!isLoggedIn()) {
    return <Navigate to="/login" state={{ from: location }} replace></Navigate>;
  }

  return children;
};

export default ProtectedRoute;
